/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */

// Self host fonts using Typefaces.js https://github.com/KyleAMathews/typefaces
// or Fontsource https://github.com/fontsource/fontsource
import 'fontsource-jost/latin-400.css';
import 'fontsource-jost/latin-500.css';
import 'fontsource-jost/latin-700.css';

import './src/css/tailwind.css';

// Lazy load intersection observer polyfill
async function onClientEntry() {
  if (typeof IntersectionObserver === 'undefined') {
    await import('intersection-observer');
    console.log('Loaded IntersectionObserver polyfill');
  }
}

export { onClientEntry };
